import { render, staticRenderFns } from "./profile_readme.vue.js?vue&type=template&id=25638314&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./profile_readme.vue?vue&type=template&id=25638314&vue3"
import script from "./profile_readme.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./profile_readme.vue?vue&type=script&lang=js&vue3"
export * from "./profile_readme.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./profile_readme.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports